import React from 'react'
import PropTypes from 'prop-types'

import FlatButton from 'material-ui/FlatButton'
import AddCustomerDialog from './CustomerInterfaces/AddCustomerDialog'
import EditCustomerDialog from './CustomerInterfaces/EditCustomerDialog'
import CustomerExportDialog from './common/CustomerExportDialog'
import CustomersTable from './CustomersTable'

import { connect } from 'react-redux'

class Customers extends React.Component {

  static propTypes = {
    teamId: PropTypes.string.isRequired,
    onCustomerSelection: PropTypes.func
  }

  constructor(props) {
    super(props)
    this.state = {
      showCustomerAddDialog: false,
      showCustomerEditDialog: false,
      showCustomerExportDialog: false,
      customerChosen: {},
      customerId: ''
    }
  }

  handleAddNewCustomer = () => {
    this.setState({ showCustomerAddDialog: false })
  }

  handleAddCustomerRequest = () => {
    this.setState({ showCustomerAddDialog: !this.state.showCustomerAddDialog })
  }

  denormalizeCustomerContact = (customer, contact) => {
    return {
      ...contact,
      name: customer.name,
      customerId: customer.customerId
    }
  }

  onCustomerSelection = (updateParent, customer, contact = {}) => {

    const customerChosen = this.denormalizeCustomerContact(customer, contact)
    this.setState({
      customerChosen,
      customerId: customer.id,
      contactId: contact.id
    })

    if (updateParent){
      this.props.onCustomerSelection(customer)
    }
  }

  onEditRequest = () => {
    this.setState({ showCustomerEditDialog: !this.state.showCustomerEditDialog })
  }

  handleImportContacts = () => {
    this.setState({ showCustomerExportDialog: !this.state.showCustomerExportDialog})
  }

  render() {
    return (
      <div style={styles.container}>
        <div style={styles.content}>
          <div style={styles.top}>
            <div style={styles.title}>Customers</div>
            <div>
              <FlatButton
                style={{border: '1px solid #e2e2e2', marginRight: 8}}
                labelStyle={{ color: '#4d6f7f' }}
                label='Import customers'
                backgroundColor='#fff'
                onTouchTap={this.handleImportContacts}/>
              <FlatButton
                style={{border: '1px solid #e2e2e2', marginLeft: 8}}
                labelStyle={{ color: '#4d6f7f' }}
                label='Create new customer'
                backgroundColor='#fff'
                onTouchTap={this.handleAddCustomerRequest}/>
            </div>
          </div>
          <CustomersTable
            teamId={this.props.teamId}
            onCustomerSelection={this.onCustomerSelection}
            onEditCustomer={this.onEditRequest}/>
        </div>

        <AddCustomerDialog
          open={this.state.showCustomerAddDialog}
          teamId={this.props.teamId}
          onSave={this.handleAddNewCustomer}
          onCloseRequest={this.handleAddCustomerRequest}/>

        <EditCustomerDialog
          open={this.state.showCustomerEditDialog}
          teamId={this.props.teamId}
          customerId={this.state.customerId}
          item={this.state.customerChosen}
          onSave={this.onEditRequest}
          onCloseRequest={this.onEditRequest}/>

        <CustomerExportDialog
          open={this.state.showCustomerExportDialog}
          teamId={this.props.teamId}
          onCloseRequest={this.handleImportContacts}/>
      </div>
    )
  }

}

const styles = {
  container: {
    backgroundColor: '#fff',
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    overflow: 'auto'
  },
  content: {
    marginLeft: 140,
    marginRight: 140,
    marginTop: 64,
    marginBottom: 64
  },
  top: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  title: {
    fontSize: 24,
    fontWeight: 400
  }
}

const mapStateToProps = state => ({
  teamId: state.firebase.team.metadata.value.id
})

export default connect(mapStateToProps)(Customers)



// WEBPACK FOOTER //
// ./src/customer/Customers.js